import React from 'react';
import Profile from '../../components/Profile';
import Description from '../../components/Description';

const Homepage = () => {
  return (
    <main>
      <div className="main-container">
        <Profile />
        <Description />
      </div>
    </main>
  );
};

export default Homepage;
